/**
     * @desc 获取公司Details
companyId
     */

import fetch from '@/utils/request'
import config from '@/config'

export interface QueryParams {
}

export function request(data: QueryParams) {
  return fetch({
    url: config.API_HOST + '/mall/common/getDictList',
    params: data,
    method: 'GET',
    credentials: 'include',
    timeout: 20 * 1000,
  })
}
